<rr-filter-bar
  #filterBar
  [filterService]="requestFilterService"
  filterEvents="handleFilterChange($event)"
  (clearFilterValues)="clearFilterValues()"
></rr-filter-bar>
